<template>
  <div id="app">
    <!-- <nav>
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </nav> -->
    <router-view/>
  </div>
</template>
<script>
	export default{
		name:'app',
		data() {
			return{
				
			}
		},
		created() {
			function isMobile(){
				if(window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
				  return true; 
				}else{
				  return false;
				}
			}
			//    判断后的操作
			if(isMobile()){
				location.href="http://h5.longwanyizhi.cn"
			}else{
				
			}
		}
	}
</script>
<style>
	body::-webkit-scrollbar {
	display: none;
	}
</style>
<style lang="less">
*{
	margin: 0;
	padding: 0;
}
</style>
